import React, { FC } from "react";
import "./HeaderLogin.scss";
import useWindowDimensions from "../../hooks/useWindowDimensions";

interface IHeaderLogin {}

const HeaderLogin: FC<IHeaderLogin> = () => {
  const { size } = useWindowDimensions();

  return (
    <div className="header text-medium-14">
      <span>
        <span className="title">Leopart</span>
        <span className="point">.</span>
      </span>
      <div>
        <div className="beta__button text-bold-14">
          {size.width >= 576 ? "Entra nella Beta Coach" : "Beta Coach"}
        </div>
      </div>
    </div>
  );
};

export default HeaderLogin;
